import { getPaymentEnvironment } from "@/lib/stripe";

export function PaymentTestModeBanner() {
  if (getPaymentEnvironment() !== "sandbox") return null;

  return (
    <div className="w-full bg-neon-yellow/20 border-b border-neon-yellow/40 px-4 py-2 text-center text-sm text-ink">
      Payments are running in Stripe test mode — no real money is charged.
    </div>
  );
}
